import * as React from 'react';

const Menu = ({ children, title = false }) => (
  <nav className="menu">
    {title && <p className="menu-label">{title}</p>}
    <ul className="menu-list">
      {children.map((link, index) => <li key={index}>{link}</li>)}
    </ul>
  </nav>
);

export default Menu;
